import {
  playerComparisonPitchEventsAtom,
  playerComparisonUnwrappedPitchEventsAtom,
} from '@/atoms/player/visComparison';
import { MetricKeyFallbackWrapper } from '@/components/metric/MetricKeyFallbackWrapper';
import { EventMap } from '@/components/visualisations/EventMap';
import { PitchVisComponentProps } from '@/types/visualisation';

export const PlayerComparisonEventMap = ({ allowInteraction, isPreview }: PitchVisComponentProps) => (
  <MetricKeyFallbackWrapper>
    <EventMap
      allowInteraction={allowInteraction}
      pitchEventsAtom={playerComparisonPitchEventsAtom}
      unwrappedPitchEventsAtom={playerComparisonUnwrappedPitchEventsAtom}
      isPreview={isPreview}
    />
  </MetricKeyFallbackWrapper>
);
